import { useLayoutEffect, useState } from 'react';
import { redesignTheme } from '../../../theme';

const HEADER_SELECTOR = '[data-redesign-app-header]';
const MOBILE_SCROLL_THRESHOLD = 40;
const DESKTOP_SCROLL_THRESHOLD = 120;

export const useNotificationBannerPosition = () => {
  const [top, setTop] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [isNarrow, setIsNarrow] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < redesignTheme.breakpoints.tablet
  );

  useLayoutEffect(() => {
    const update = () => {
      const header = document.querySelector(HEADER_SELECTOR);
      const narrow = window.innerWidth < redesignTheme.breakpoints.tablet;

      if (header) {
        setTop(Math.max(0, header.getBoundingClientRect().bottom));
      }

      setIsNarrow(narrow);
      setIsVisible(
        window.scrollY < (narrow ? MOBILE_SCROLL_THRESHOLD : DESKTOP_SCROLL_THRESHOLD)
      );
    };

    update();
    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);

    return () => {
      window.removeEventListener('scroll', update, true);
      window.removeEventListener('resize', update);
    };
  }, []);

  return { top, isVisible, isNarrow };
};
